import React from 'react';
import { IconProps } from '../types/types';

const EURTRY: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path d="M13.027 0v26.05c7.194 0 13.026-5.83 13.026-13.024C26.053 5.832 20.221 0 13.027 0Z" fill="#214391" />
        <path d="M13.025 0C5.832 0 0 5.832 0 13.026s5.832 13.025 13.025 13.025c7.194 0 7.194-26.05 0-26.05Z" fill="#2B479D" />
        <path
            d="m13.002 2.259.318.978h1.028l-.832.604.318.978-.832-.605-.831.605.317-.978-.832-.604h1.029l.317-.978ZM13.002 20.716l.318.979h1.028l-.832.604.318.977-.832-.604-.831.604.317-.977-.832-.604h1.029l.317-.979ZM18.069 3.895l.317.978h1.028l-.832.604.318.978-.831-.605-.832.605.317-.978-.831-.604h1.028l.317-.978ZM21.526 7.305l.317.977h1.029l-.832.605.318.977-.832-.604-.832.604.318-.977-.832-.605h1.028l.318-.977ZM21.61 15.92l.317.978h1.029l-.832.604.318.978-.832-.604-.832.604.318-.978-.832-.604h1.028l.318-.978ZM4.608 7.305l.317.977h1.028l-.831.605.317.977-.831-.604-.832.604.317-.977-.831-.605H4.29l.318-.977ZM22.326 11.414l.318.977h1.028l-.832.604.318.979-.832-.605-.831.604.318-.978-.832-.604h1.028l.317-.977ZM3.82 11.414l.318.977h1.028l-.832.604.318.979-.831-.605-.832.604.318-.978-.832-.604h1.028l.318-.977ZM4.494 15.92l.318.978H5.84l-.832.604.318.978-.832-.604-.831.604.317-.978-.832-.604h1.029l.317-.978ZM18.217 19.476l.318.977h1.028l-.832.605.318.978-.832-.605-.832.605.318-.978-.832-.605H17.9l.318-.977ZM8.102 3.895l.317.978h1.029l-.832.604.318.978-.832-.605-.832.605.318-.978-.832-.604h1.028l.318-.978ZM7.729 19.413l.317.978h1.029l-.832.604.318.978-.832-.604-.832.604.318-.978-.832-.604H7.41l.318-.978Z"
            fill="#F8D12E"
        />
        <path d="M25.33 40.91c7.5 0 13.58-6.08 13.58-13.58s-6.08-13.58-13.58-13.58-13.58 6.08-13.58 13.58 6.08 13.58 13.58 13.58Z" fill="#F0F0F0" stroke="#fff" strokeWidth={0.5} />
        <mask
            id="eurtry_svg__a"
            style={{
                maskType: 'alpha'
            }}
            maskUnits="userSpaceOnUse"
            x={12}
            y={14}
            width={27}
            height={27}
        >
            <path d="M25.5 41C32.956 41 39 34.956 39 27.5S32.956 14 25.5 14 12 20.044 12 27.5 18.044 41 25.5 41Z" fill="#D80027" />
        </mask>
        <g mask="url(#eurtry_svg__a)">
            <path d="M51.002 14H9.998v27.8h41.004V14Z" fill="#E20A17" />
            <path
                d="M30.144 24.2c-.355-.341-1.924-1.747-4.144-1.63-2.635.134-5.137 2.37-5.3 5.108-.148 2.62 1.91 4.322 2.117 4.47 1.94 1.54 4.16 1.17 4.515 1.096a5.697 5.697 0 0 0 2.842-1.436c-.4.636-1.273 1.776-2.783 2.502-2.442 1.17-5.714.8-7.816-1.318-2.132-2.161-1.969-4.988-1.94-5.447.178-2.384 1.57-4.752 3.88-5.847 2.012-.963 3.922-.578 4.529-.43 2.517.637 3.804 2.487 4.1 2.931Z"
                fill="#fff"
            />
            <path d="M32.203 24.688v2.62l-2.28.696 2.28.755v2.546l1.51-2.014 2.325.755-1.348-2.042 1.348-1.97-2.28.785-1.555-2.131Z" fill="#fff" />
        </g>
    </svg>
);

export default EURTRY;
